import Vue from 'vue'

const state = {
  building: {},
  buildings: []
}

const mutations = {
  SET_BUILDING ({ commit }, value) {
    state.building = value || {}
  },
  SET_BUILDINGS ({ commit }, value) {
    state.buildings = value || []
  },
  ADD_BUILDING ({ commit }, value) {
    state.buildings.push(value)
  },
  REMOVE_BUILDING ({ commit }, value) {
    state.buildings.splice(state.buildings.indexOf(value), 1)
  }
}

const actions = {
  getBuildings ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}building/getall`)
        .then(response => {
          commit('SET_BUILDINGS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBuildingsByLocation ({ commit }, locationID) {
    var params = typeof locationID !== 'undefined' ? `?locationID=${locationID}` : ''

    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}building/getbylocation${params}`)
        .then(response => {
          commit('SET_BUILDINGS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createBuilding ({ commit }, building) {
    return new Promise((resolve, reject) => {
      var location = building.locationId !== null ? { Id: building.locationId } : null

      Vue.axios.post(`${window.config.apiUrl}building/create`, {
        Name: building.name,
        Location: location
      })
        .then(response => {
          if (response.data !== '') {
            commit('ADD_BUILDING', response.data)
            resolve(response)
          } else {
            reject(new Error('Building already exists.'))
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateBuilding ({ commit }, building) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}building/update`, {
        ID: building.ID,
        Name: building.Name
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteBuilding ({ commit }, building) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}building/delete`, {
        ID: building.ID
      })
        .then(response => {
          if (response.data) {
            commit('REMOVE_BUILDING', building)
            resolve(response)
          } else {
            reject(new Error('Something went wrong.'))
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getters = {
  building () {
    return state.building
  },
  buildings () {
    return state.buildings
  },
  buildingsByLocation () {
    // Group by section name
    // Resource: https://goo.gl/hlpGx
    return state.buildings.reduce((acc, item) => {
      var key = item.Location.Name
      acc[key] = acc[key] || []
      acc[key].push(item)
      return acc
    }, {})
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/buildings.js